import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Paper from '@material-ui/core/Paper';

import Thumbnail from './thumb';
import ContentBox from './contentBox';
import Actions from './actions';
import styles from './styles';

function PropertyCard(props) {
  const { classes, data, isLink, to, key } = props;

  const { property, propertyType } = data;

  const content = [
    { title: 'Name', value: _.get(property, 'propertyTitle') },
    { title: 'District', value: _.get(property, 'propertyAdress.district') },
    {
      title: 'Area',
      value: `${_.get(property, 'propertyArea.value')} ${_.get(property, 'propertyArea.measuringUnit')}`,
    },
  ];

  const renderCard = (
    <Paper elevation={2} className={classes.leasecardItem}>
      <sup className={classes.badge}>{propertyType?.subType}</sup>
      <div className={classes.contentContainer}>
        <Thumbnail image={property?.image} title={property?.propertyTitle} />

        <div className={classes.detailsHolder}>
          {content.map(
            (item, i) =>
              item.value && (
                <ContentBox
                  key={item.value}
                  title={item.title}
                  value={item.value}
                  boldTitle={item.title === 'Name'}
                  isFirst={i === 0}
                />
              ),
          )}
        </div>
      </div>

      <Actions
        data={[
          { text: property?.ownershipType, color: 'info' },
          { text: property?.state, color: property?.state === 'Vacant' ? 'success' : 'warning' },
        ]}
      />
    </Paper>
  );

  if (isLink) {
    return (
      <Link className={classes.link} to={to} key={key}>
        {renderCard}
      </Link>
    );
  }

  return <Fragment>{renderCard}</Fragment>;
}

PropertyCard.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  isLink: PropTypes.bool,
  to: PropTypes.string,
  key: PropTypes.string.isRequired,
};

PropertyCard.defaultProps = {
  isLink: false,
  to: '',
};

export default withStyles(styles)(injectIntl(PropertyCard));
